<div>
  <deprecated-select-dropdown
    display="Columns"
    class="button"
    [options]="options | async"
    [pinned]="pinned | async"
    [multiSelect]="true"
    [hideCount]="true"
    [ngModel]="selectedColumns | async"
    (ngModelChange)="selectEvent.next($event)"
    (onDragEvent)="onDragEvent.next($event)"
    (onPinnedEvent)="onPinnedEvent.next($event)"
    [draggable]="true"
    [dragScrollable]="true"
    [selectedEnabled]="false"
  ></deprecated-select-dropdown>
</div>
